<template>
    <div class="min-h-screen bg-[#f6f4f1] text-gray-800 font-sans flex flex-col justify-center items-center p-6">

        <!-- Header -->
        <header class="bg-[#152a34] text-white py-8 px-6 text-center shadow-lg w-full max-w-xl rounded-t-xl">
            <h1 class="text-4xl font-extrabold mb-2">Confirmação de Cadastro</h1>
        </header>

        <!-- Card -->
        <div class="container mx-auto max-w-xl bg-white rounded-b-2xl shadow-xl p-8 text-center 
                    min-h-[300px] flex flex-col justify-center items-center">

            <!-- Loading -->
            <div v-if="isLoading" class="flex flex-col items-center">
                <v-progress-circular
                    indeterminate
                    color="#152a34"
                    size="50"
                    class="mb-4"
                ></v-progress-circular>

                <p class="text-lg font-medium text-[#152a34]">
                    Verificando a sua conta...
                </p>
            </div>

            <!-- Sucesso -->
            <div v-else-if="confirmationStatus === 'success'" class="text-center">
                <svg xmlns="http://www.w3.org/2000/svg"
                     class="w-20 h-20 text-green-600 mx-auto mb-4"
                     viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 
                          7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                          clip-rule="evenodd" />
                </svg>

                <h2 class="text-3xl font-bold text-gray-900 mb-3">
                    Cadastro Confirmado!
                </h2>

                <p class="text-lg text-gray-600 mb-6">
                    Sua conta foi ativada com sucesso. Você já pode acessar a plataforma!
                </p>

                <button
                    @click="redirectToApp"
                    class="px-8 py-3 bg-[#152a34] hover:bg-[#0f1e25] text-white rounded-xl 
                           font-semibold shadow-md transition duration-300"
                >
                    Ir para o Aplicativo
                </button>
            </div>

            <!-- Erro -->
            <div v-else-if="confirmationStatus === 'error'" class="text-center">
                <svg xmlns="http://www.w3.org/2000/svg"
                     class="w-20 h-20 text-red-600 mx-auto mb-4"
                     viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 
                          1.414L8.586 10l-1.293 1.293a1 1 0 101.414 
                          1.414L10 11.414l1.293 1.293a1 1 0 
                          001.414-1.414L11.414 10l1.293-1.293a1 1 0 
                          00-1.414-1.414L10 8.586 8.707 7.293z"
                          clip-rule="evenodd" />
                </svg>

                <h2 class="text-3xl font-bold text-gray-900 mb-3">
                    Falha na Confirmação
                </h2>

                <p class="text-lg text-gray-600 mb-6">
                    {{ errorMessage }}
                </p>

                <button
                    @click="redirectToApp"
                    class="px-8 py-3 border border-gray-400 text-gray-700 
                           hover:bg-gray-100 rounded-xl font-semibold shadow-sm transition duration-300"
                >
                    Voltar para o Login
                </button>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import api from "@/services/api"; 
import { useToastStore } from "@/store/toast";

const route = useRoute();
const toastStore = useToastStore();

const isLoading = ref(true);
const confirmationStatus = ref(null);
const errorMessage = ref('O link de confirmação é inválido ou já expirou.');

async function confirmUser() {
    isLoading.value = true;
    
    const reference = route.params.reference;
    const hash = route.params.hash;

    if (!reference || !hash) {
        errorMessage.value = 'Parâmetros de confirmação ausentes na URL.';
        confirmationStatus.value = 'error';
        isLoading.value = false;
        return;
    }

    try {
        const response = await api.post(`/auth/confirm-registration`, {
            reference,
            hash
        });

        confirmationStatus.value = 'success';
        /*toastStore.showToast({
            message: response.data.message || 'Cadastro confirmado!',
            color: 'success'
        });*/

    } catch (error) {
        confirmationStatus.value = 'error';
        const apiError = error?.response?.data?.error;

        if (apiError) errorMessage.value = apiError;

       /* toastStore.showToast({
            message: apiError || 'Erro na confirmação. Tente novamente.',
            color: 'error'
        });*/

    } finally {
        isLoading.value = false;
    }
}

function redirectToApp() {
    const appUrl = process.env.VUE_APP_URL || '/';
    window.location.href = appUrl;
}

onMounted(() => confirmUser());
</script>

<style scoped>

</style>
